import React, {Component} from "react";
import {Button, message, Switch} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import {hasAuth} from "../../../utils/NHCore";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import css from './index.css';
import NHContainerFrame from '../../common/NHContainerFrame';
import AddOrEditForm from "./AddOrEditForm";
import ViewForm from './ViewForm';

const basicUrl = '/fwwgl/dhlm/';

/**
 * 迎新系统-服务网管理-导航栏目
 */
class IndexComponet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},            //初始化表单信息
            frameVisibleMap: {
                tableFlag: true,         //列表Tab显示标志
                addFlag: false,          //新增Tab显示标志
                updateFlag: false,       //修改Tab显示标志
                viewFlag: false,         //查看Tab显示标志
                showOperationBtn: false, //按钮显示标志
            },
            tempData: {},                //当前操作的行数据
            updatePkid: '',              //修改信息时，对应数据的pkid
            dhlmDetailData: {},          //导航栏目详情信息
            tyzt: '',                    //停用状态
            qyzt: '',                    //启用状态
        };
    }

    componentDidMount() {
        NHFetch("/proData/selectDataList", "GET", {sign: 'dmk_xtgl_zt'})
            .then(resData => {
                if (resData.data != null) {
                    if (resData.data[0] != null && resData.data[1] != null && resData.data[0].VALUE === '1' && resData.data[1].VALUE === '0') {
                        this.setState({tyzt: resData.data[1].LABEL, qyzt: resData.data[0].LABEL});
                    }
                }
            })
    }

    //设置当前显示页面
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            frameVisibleMap[name] = name === showFlagName;
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    };

    //新增提交
    handleAddSubmit = () => {
        const form = this.form;
        form.validateFields((err, formData) => {
            if (err) {
                return;
            }
            const {zt, flbz, lmlx, flmid} = formData;
            formData.zt = zt ? '1' : '0';
            if (lmlx === '1') {        //信息发布类型
                formData.lmlj = '';
                formData.flmid = flmid ? flmid : '-1';
                // if (formData.flbz.length <= 0) {
                //     message.warning("请选择分类标志！");
                //     return;
                // }
                formData.flbz = (flbz && flbz.length > 0) ? flbz[flbz.length - 1] : '';
            } else if (lmlx === '2') { //链接类型
                formData.flbz = '';
                formData.flmid = formData.ljlxFlmid ? formData.ljlxFlmid : '-1';
                if (!formData.lmlj) {
                    message.warning("请填写栏目链接！");
                    return;
                }
            }

            NHFetch(basicUrl + "insert", "POST", formData)
                .then(resData => {
                    if (resData.data) {
                        message.success("新增成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    }
                })
        });
    };

    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        if (record) {
            let lmlx = record.LMLX;
            if (lmlx === '3') {
                message.warning("特定模块栏目不能修改！");
                return;
            }

            let pkid = record.PKID;
            this.setCurrentPageShow("updateFlag");
            this.setState({updatePkid: pkid});
            this.setState({
                formInitData: {
                    pkid: record.PKID,
                    lmmc: record.LMMC,
                    lmlx: record.LMLX,
                    lmsx: record.LMSX,
                    lmlj: record.LMLJ,
                    flmid: record.FLMID,
                    ljlxFlmid: record.FLMID,
                    mrlm: record.MRLM,
                    xsfs: record.XSFS,
                    pxh: record.PXH,
                    zt: record.ZT,
                    mkbz: record.MKBZ,
                    flbz: record.FLBZ
                }
            });
        }
    };

    //修改提交
    handleUpdateSubmit = () => {
        const form = this.form;
        let nhTable = this.refs.nhTable;
        form.validateFields((err, formData) => {
            if (err) {
                return;
            }
            formData.pkid = this.state.updatePkid;
            const {zt, flbz, lmlx, flmid} = formData;
            formData.zt = zt ? '1' : '0';


            if (lmlx === '1') {        //信息发布类型
                formData.lmlj = '';
                formData.flmid = flmid ? flmid : '-1';
                // if (formData.flbz.length <= 0) {
                //     message.warning("请选择分类标志！");
                //     return;
                // }
                formData.flbz = (flbz && flbz.length > 0) ? flbz[flbz.length - 1] : '';
            } else if (lmlx === '2') { //链接类型
                formData.flbz = '';
                formData.flmid = formData.ljlxFlmid ? formData.ljlxFlmid : '-1';
                if (!formData.lmlj) {
                    message.warning("请填写栏目链接！");
                    return;
                }
            }

            NHFetch(basicUrl + "update", "POST", formData)
                .then(resData => {
                    if (resData.data) {
                        message.success("修改成功！");
                        this.setState({formInitData: {}, updatePkid: ''});
                        this.setCurrentPageShow("tableFlag");
                        nhTable.filterTableData();
                    } else {
                        message.error("修改失败！");
                    }
                })
        });
    };

    //关闭编辑页面时
    handleFrameClose = () => {
        this.setCurrentPageShow('tableFlag');
        this.setState({formInitData: {}, updatePkid: ''});
        this.refs.nhTable.filterTableData();
    };

    //编辑页面确认时
    handleFrameOk = () => {
        if (this.state.updatePkid === '') {
            this.handleAddSubmit();
        } else {
            this.handleUpdateSubmit();
        }
    };

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setCurrentPageShow('addFlag');
    };

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        let lmsx = record.LMSX;
        if (lmsx === '1') {
            message.warning("固定栏目不能删除！");
            return;
        }

        let lmlx = record.LMLX;
        if (lmlx === '3') {
            message.warning("特定模块栏目不能删除！");
            return;
        }

        NHConfirm({
            content: "删除栏目，会将该栏目下的子栏目一并删除，此操作不可恢复！确定删除？", type: "danger", onOk: () => {
                let pkid = record.PKID;
                this.handleDelete([pkid]);
            }
        });
    };

    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        let selectedRows = this.refs.nhTable.state.selectedRows;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            for (let i in selectedRows) {
                if (selectedRows[i].LMSX === '1') {
                    message.warning("固定栏目不能删除！");
                    return;
                }
                if (selectedRows[i].LMLX === '3') {
                    message.warning("特定模块栏目不能删除！");
                    return;
                }
            }
            NHConfirm({
                content: "删除栏目，会将该栏目下的子栏目一并删除，此操作不可恢复！确定删除？", type: "danger", onOk: () => {
                    this.handleDelete(selectedRowKeys);
                }
            });
        } else {
            message.warning("请先选择需要删除的数据！");
        }
    };

    //删除操作
    handleDelete = (pkids) => {
        NHFetch(basicUrl + 'deleteByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    if (res.data) {
                        message.success("删除操作成功！");
                        this.setState({showOperationBtn: false});
                        this.refs.nhTable.filterTableData();
                    }
                }
            })
    };

    //查看按钮点击事件
    handleViewBtnClick = (record) => {
        this.setState({dhlmDetailData: record});
        this.setCurrentPageShow('viewFlag');
    };

    // table选择row后出现操作按钮
    rowSelectionChange = (selectedRowKeys) => {
        this.setState({
            showOperationBtn: selectedRowKeys.length ? true : false
        });
    };

    saveFormRef = (form) => {
        this.form = form;
    };

    //单行启用禁用
    updateState = (record, value) => {
        let PKID = record.PKID;
        NHFetch(basicUrl + "updateState", "POST", {"pkid": PKID, zt: value ? '1' : '0'})
            .then(res => {
                if (res && res.code == 200) {
                    message.success("操作成功");
                } else {
                    message.warn("操作异常");
                }
                this.refs.nhTable.readTableData();
            });
    };

    //设置是否默认栏目
    updateMrlm = (record, value) => {
        let pkid = record.PKID;
        let param = {"pkid": pkid, mrlm: value ? '1' : '0'};
        NHFetch(basicUrl + "updateMrlm", "POST", param)
            .then(res => {
                if (res && res.code == 200) {
                    message.success("操作成功");
                } else {
                    message.warn("操作异常");
                }
                this.refs.nhTable.readTableData();
            });
    };

    render() {
        const columns = [
            {
                title: '序号',
                width: '60px',
                dataIndex: 'ROW_ID'
            }, {
                title: '栏目名称',
                width: '150px',
                key: 'lmmc',
                dataIndex: 'LMMC',
                search: 'input',
                searchType:"input"
            }, {
                title: '导航栏项类型',
                width: '150px',
                key: 'lmlxmc',
                dataIndex: 'LMLXMC',
                commonSearch: false,
                sorted: false,
                searchType:"select"
            }, {
                title: '栏目属性',
                width: '150px',
                key: 'lmsxmc',
                dataIndex: 'LMSXMC',
                commonSearch: false,
                sorted: false,
                searchType:"select"
            },
            {
                title: '栏目链接',
                width: '200px',
                key: 'lmlj',
                dataIndex: 'LMLJ',
                search: 'input',
                searchType:"input"
            },
            {
                title: '父栏目',
                width: '150px',
                key: 'flmmc',
                dataIndex: 'FLMMC',
                commonSearch: false,
                searchType:"input"
            },
            {
                title: '默认栏目',
                width: '150px',
                key: 'mrlmmc',
                dataIndex: 'MRLMMC',
                commonSearch: false,
                sorted: false,
                searchType:"select"
            },
            {
                title: '是否设置为默认栏目',
                width: '150px',
                key: 'mrlm',
                dataIndex: 'MRLM',
                commonSearch: false,
                sorted: false,
                render: (text, record, index) => {
                    const status = record.MRLM === '1';
                    return (
                        hasAuth('zhxg_yxgl_fwwgl_dhlmgl:updateMrlm') ?
                            <Switch checkedChildren="是" unCheckedChildren="否"
                                    checked={status}
                                    onChange={(value) => this.updateMrlm(record, value)}/> :
                            <span>{status ? '是' : '否'}</span>
                    );
                },
                searchType:"select"
            },
            {
                title: '显示方式',
                width: '150px',
                key: 'xsfsmc',
                dataIndex: 'XSFSMC',
                commonSearch: false,
                sorted: false,
                searchType:"input"
            },
            {
                title: '状态',
                width: '150px',
                key: 'zt',
                dataIndex: 'ZT',
                commonSearch: false,
                sorted: false,
                render: (text, record, index) => {
                    const status = record.ZT === '1';
                    return (
                        hasAuth('zhxg_yxgl_fwwgl_dhlmgl:updateState') ?
                            <Switch checkedChildren={this.state.qyzt} unCheckedChildren={this.state.tyzt}
                                    checked={status}
                                    onChange={(value) => this.updateState(record, value)}/> :
                            <span>{status ? this.state.qyzt : this.state.tyzt}</span>
                    );
                },
                searchType:"select"
            },
            {
                title: '模块标志',
                width: '150px',
                key: 'dhlmmkbz',
                dataIndex: 'DHLMMKBZ',
                search: 'input',
                searchType:"input"
            },
            {
                title: '分类标志',
                width: '150px',
                key: 'dhlmflbt',
                dataIndex: 'DHLMFLBT',
                search: 'input',
                searchType:"input"
            },
            {
                title: '排序号',
                width: '150px',
                key: 'pxh',
                dataIndex: 'PXH',
                commonSearch: false,
                searchType:"input"
            }
        ];

        //行内操作
        const action = [
            {title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxgl_fwwgl_dhlmgl:button_update'},
            {title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxgl_fwwgl_dhlmgl:button_delete'},
            {title: '查看', onClick: this.handleViewBtnClick, auth: "zhxg_yxgl_fwwgl_dhlmgl:button_view"},
        ];

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div className={css.table} style={{display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none'}}>
                    <NHTable ref="nhTable"
                             rowKey={record => record.PKID}
                             sign={'zhxg_yxxt_fwwgl_dhlm_queryPage'}
                             columns={columns}
                             action={action}
                             rowSelectionChange={this.rowSelectionChange}>
                        {hasAuth("zhxg_yxgl_fwwgl_dhlmgl:button_add") &&
                        <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>}
                        {(this.state.showOperationBtn && hasAuth("zhxg_yxgl_fwwgl_dhlmgl:button_delete")) &&
                        <Button type="danger" ghost style={{marginLeft: 10}}
                                onClick={this.handleMultiDeleteBtnClick}>删除</Button>}
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhShowModal"
                                  visible={this.state.frameVisibleMap.viewFlag}
                                  title={this.state.dhlmDetailData.LMMC + '—栏目详情'}
                                  footer={null}
                                  onCancel={this.handleFrameClose}>
                    <ViewForm initViewFormData={this.state.dhlmDetailData}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhAddModal"
                                  title="新增导航栏目"
                                  visible={this.state.frameVisibleMap.addFlag}
                                  contentWidth={24}
                                  onOk={this.handleFrameOk}
                                  onCancel={this.handleFrameClose}>
                    <AddOrEditForm ref={this.saveFormRef} initData={this.state.formInitData}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                                  title="修改导航栏目"
                                  visible={this.state.frameVisibleMap.updateFlag}
                                  contentWidth={24}
                                  onOk={this.handleFrameOk}
                                  onCancel={this.handleFrameClose}>
                    <AddOrEditForm ref={this.saveFormRef} initData={this.state.formInitData}/>
                </NHContainerFrame>
            </div>
        );
    }
}

export default IndexComponet;



// WEBPACK FOOTER //
// ./components/fwwgl/dhlm/index.js